@if (
  {
    expanded: (expanded$ | async)!
  };
  as context
) {
  <now-wbsuche-lib-basis-facette
    [id]="'umkreis'"
    [label]="'Umkreis'"
    [facettenService]="facettenService"
    [isLoading]="(this.loaderService.facettenLoadingFirstTime$ | async)!"
  >
    <now-wbsuche-lib-facetten-modal-button [modalId]="'umkreis'" [buttonText]="'Informationen'">
    </now-wbsuche-lib-facetten-modal-button>
    @if (context.expanded) {
      <div id="umkreisFacette" class="mt-2">
        <now-wbsuche-lib-ort-suchumkreis class="suchumkreis"> </now-wbsuche-lib-ort-suchumkreis>
      </div>
    }
  </now-wbsuche-lib-basis-facette>
}
